import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './calendar.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DayPilotModule } from 'daypilot-pro-angular';
import { RouterModule } from '@angular/router';
//import { DraggableDirective } from 'src/app/_directives/draggable.directive';
import { SharedModule } from '../../shared/shared.module';
import { MatIconModule} from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DispoProtokollComponent } from './dispo-protokoll/dispo-protokoll.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { NoteModule } from '../note/note.module';

import { NgxColorsModule } from 'ngx-colors';
import { TeamLocationComponent } from './team-location/team-location.component';
import { TeamAbsencesComponent } from './team-absences/team-absences.component';
import { DefaultWorkingTimesComponent } from './team-absences/default-working-times/default-working-times.component';
import { TeamAbsenceBaseComponent } from './team-absences/team-absence-base/team-absence-base.component';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { TeamDetailsComponent } from './team-details/team-details.component';
import { TeamBaseComponent } from './team-base/team-base.component';
import { TeamOrderComponent } from './team-order/team-order.component';
import { TeamDayViewComponent } from './team-dayview/team-dayview.component';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatSelectModule } from '@angular/material/select';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS  } from "@angular/material-moment-adapter";
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';


@NgModule({
  declarations: [
    CalendarComponent,
    DispoProtokollComponent,
    TeamDetailsComponent,
    TeamBaseComponent,
    //TeamOrderDetailsComponent,
    TeamOrderComponent,
    TeamDayViewComponent,
    TeamLocationComponent,
    TeamAbsencesComponent,
    TeamAbsenceBaseComponent,
    DefaultWorkingTimesComponent,
    CalendarComponent
  
  ],
  imports: [
    CommonModule,
    //DraggableDirective,
    PerfectScrollbarModule,
    NgbModule,
    FormsModule,
    DayPilotModule,
    ReactiveFormsModule,
    SharedModule,
    MatIconModule,
    MatTabsModule,
    AgmCoreModule,
    AgmDirectionModule,
    DragDropModule,
    NgxPaginationModule,
    MatMenuModule,
    MatDividerModule,
    NoteModule,

    PerfectScrollbarModule,
    NgbModule,
    FormsModule,
    MatTabsModule,
    MatPaginatorModule,
    MatExpansionModule,
    ReactiveFormsModule,
    SharedModule,
    DayPilotModule,
    NgxColorsModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,

    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatProgressBarModule,
    RouterModule,
    MatListModule

    /*
    RouterModule.forChild([
      {
        path: '',
        component: CalendarComponent,
        children: [
          {
            path: 'team/:id',
            component: TeamDetailsComponent,
            children: [
              {
                path: 'team-base',
                component: TeamBaseComponent
              },
              {
                path: 'team-location',
                component: TeamLocationComponent
              },
              {
                path: 'team-absences',
                component: TeamAbsencesComponent,
                children: [
                  {
                    path: ':id/team-absence-base',
                    component: TeamAbsenceBaseComponent
                  },
                  {
                    path: 'default-working-times',
                    component: DefaultWorkingTimesComponent
                  },
                ]
              },
              {
                path: 'team-dayview',
                component: TeamDayViewComponent
              },
           
              
            ]
          },
          {
            path: 'order/:id',
            //component: TeamOrderDetailsComponent,
            children: [
              {
                path: 'team-order',
                component: TeamOrderComponent
              },
              
            ]
          },
        ]
      }
    ])
    */

    //SidebarModule.forRoot(),
   
  ],
  exports: [
    CalendarComponent,
    TeamDetailsComponent,
    TeamBaseComponent,
    TeamLocationComponent,
    TeamAbsencesComponent,
    TeamAbsenceBaseComponent,
    DefaultWorkingTimesComponent,
    TeamDayViewComponent,
    TeamOrderComponent
  ]
})
export class CalendarModule { }
